var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 193 89 193 89 157 116.38 157 118.82 151 87 151C84.7909 151 83 152.791 83 155L83 195C83 197.209 84.7909 199 87 199L120 199Z",
    fill: "#116D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 166 163 166 163 155C163 152.791 161.209 151 159 151L130 151 130 157 157 157 157 193 135 193 132.35 199 159 199C161.209 199 163 197.209 163 195L163 184 167 184C169.209 184 171 182.209 171 180L171 170C171 167.791 169.209 166 167 166Z",
    fill: "#116D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 174 126 144 109.69 183.97 124 184 124 208 139 174 126 174Z",
    fill: "#116D6E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.7929eec90c94e0a386eb444d7f41d13a.svg";
export { ForwardRef as ReactComponent };